import React from 'react';
import './Marquee.css';

const Marquee: React.FC = () => {
  return (
    <div className="marquee">
      <div className="marquee-content">
        Welcome to our website! Enjoy the latest updates and offers.
      </div>
    </div>
  );
};

export default Marquee;
